export * from './FooterScript';
export * from './GlobalFooter';
